



























































































































import { Component, Vue, Prop } from "vue-property-decorator";
import { AnalysisSummaryDTO } from "@/api/analyses/types";
import { formattedDate } from "@/filters/date";
import { formattedAreaInHa } from "@/filters/area";
import { percentFilter } from "@/filters/percent";
import { formattedYield } from "@/filters/yield";
import Icon from "@/components/agroIcons/AgroIcons.vue";

@Component({
  name: "MonitoringSummary",
  components: {Icon},
  filters: {
    formattedDate,
    formattedAreaInHa,
    percentFilter,
    formattedYield,
  },
})
export default class MonitoringSummary extends Vue {
  @Prop({ type: Object, required: true })
  private summaryInfo!: AnalysisSummaryDTO;

  @Prop({ type: String })
  private pipelineVersion!: string
  
  @Prop({ type: String, required: false })
  private cropIdVersion!: string;

  @Prop({ type: String, required: false })
  private yieldestVersion!: string;

  get version() {
    return `${this.$t('info-tooltip.version.version-label')}
  - ${this.$t('info-tooltip.version.pipeline-label')}: ${this.pipelineVersion}
  - ${this.$t('info-tooltip.version.crop-id-label')}: ${this.cropIdVersion}
  - ${this.$t('info-tooltip.version.yieldest-label')}: ${this.yieldestVersion}`
  }
}
